import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { withRouter, useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import { ChromePicker } from 'react-color';
import domtoimage from 'dom-to-image';
import EditTool from './Sections/EditTool';
import KakaoShareBtn from '../../utils/KakaoShareBtn';
import { useSelector } from 'react-redux';
import firebase from 'firebase';

function EditPage(props) {
  // params
  const location = useLocation();
  const zzalId = props.match.params.zzalId;
  const link = location.state ? location.state.link : '';

  // state
  const [text, setText] = useState('');
  const [image, setImage] = useState('');
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState('32px');
  const [color, setColor] = useState('black');
  const [showColorPicker, setShowColorPicker] = useState(false);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (!link) {
      alert('잘못된 접근입니다.');
      props.history.push('/');
    }
    const data = new FormData();
    data.append('file', link);
    data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);
    data.append('cloud_name', process.env.REACT_APP_CLOUD_NAME);
    fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      {
        method: 'post',
        body: data,
      }
    )
      .then((resp) => resp.json())
      .then((temp) => {
        let url = temp.url.substring(5);
        setImage(url);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  const onChangeHandler = (e) => {
    setText(e.currentTarget.value);
  };

  const downloadHandler = () => {
    domtoimage
      .toBlob(document.querySelector('#edit-zzal'))
      .then((blob) => {
        saveAs(blob, 'zzal.png');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addZzalHandler = () => {
    if (!user && !user.isLogin) {
      alert('로그인 후 이용 가능합니다.');
      props.history.push('/login');
    } else {
      domtoimage.toPng(document.querySelector('#edit-zzal')).then((img) => {
        const data = new FormData();
        data.append('file', img);
        data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);
        data.append('cloud_name', process.env.REACT_APP_CLOUD_NAME);
        fetch(
          `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
          {
            method: 'post',
            body: data,
          }
        )
          .then((resp) => resp.json())
          .then((temp) => {
            let url = temp.url.substring(5);
            firebase
              .database()
              .ref('zzals/' + localStorage.getItem('u_id'))
              .push()
              .set({
                id: Date.now() + Math.floor(Math.random() * 100),
                link: url,
              })
              .then((doc) => {
                alert('내 짤주머니에 저장!');
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => console.log(err));
      });
    }
  };

  const textSizeHandler = (e) => {
    setSize(e.target.value);
  };

  const colorHandler = (e) => {
    setColor(e.target.value);
  };

  const popPickerHandler = () => {
    setShowColorPicker(true);
  };

  const hexColorHandler = (color) => {
    setColor(color.hex);
  };

  const closeColorPicker = () => {
    setShowColorPicker(false);
  };

  const onKakaoShare = () => {
    domtoimage.toPng(document.querySelector('#edit-zzal')).then((img) => {
      const data = new FormData();
      data.append('file', img);
      data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);
      data.append('cloud_name', process.env.REACT_APP_CLOUD_NAME);
      fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
        {
          method: 'post',
          body: data,
        }
      )
        .then((resp) => resp.json())
        .then((temp) => {
          const { Kakao } = window;
          Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
              title: text,
              description: '#짤방 #짤해 #커스텀짤 #짤생성',
              imageUrl: temp.url,
              link: {
                webUrl: 'https://zzal-debug.web.app/',
                mobileWebUrl: 'https://zzal-debug.web.app/',
              },
            },
            buttons: [
              {
                title: '더 많은 짤을 찾아..',
                link: {
                  webUrl: 'https://zzal-debug.web.app/',
                  mobileWebUrl: 'https://zzal-debug.web.app/',
                },
              },
            ],
          });
        })
        .catch((err) => console.log(err));
    });
  };

  const errorHandler = (e) => {
    e.target.src = `https://res.cloudinary.com/${process.env.REACT_APP_CLOUD_NAME}/image/upload/v1622789406/icon/zzal_tl6ooy_obtlyv.jpg`;
  };

  return (
    <div
      style={{
        width: '100%',
        padding: '3rem 4rem',
        marginTop: '7rem',
        overflow: 'hidden',
      }}
    >
      <Row gutter={[16, 16]}>
        <Col lg={12} sm={24} xs={24} style={{ textAlign: 'center' }}>
          <div
            id='edit-zzal'
            style={{
              position: 'relative',
              display: 'inline-block',
              width: '400px',
            }}
          >
            <label
              style={{
                position: 'absolute',
                bottom: '10px',
                left: '10px',
                zIndex: 5,
                color: color,
                fontSize: size,
                fontWeight: 'bold',
                maxHeight: '100%',
                overflowY: 'hidden',
              }}
            >
              {text}
            </label>
            <img
              id='zzal-img'
              style={{
                border: '1px solid #ccc',
                width: '100%',
                boxShadow: '0 4px 5px #ccc',
              }}
              src={loading ? link : image}
              alt='#'
              onError={errorHandler}
            />
          </div>
        </Col>
        <Col lg={12} sm={24} xs={24} style={{ textAlign: 'center' }}>
          <div style={{ position: 'relative' }}>
            <EditTool
              info={{ id: zzalId, link }}
              onChange={onChangeHandler}
              onDownload={downloadHandler}
              onAdd={addZzalHandler}
              onSize={textSizeHandler}
              onColor={colorHandler}
              onPop={popPickerHandler}
            />
            {showColorPicker ? (
              <div
                style={{
                  position: 'absolute',
                  top: 'calc(50% - 120px)',
                  left: 'calc(50% - 120px)',
                  zIndex: '100',
                }}
              >
                <div
                  style={{
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                  }}
                  onClick={closeColorPicker}
                />
                <ChromePicker
                  color={color}
                  onChangeComplete={hexColorHandler}
                />
              </div>
            ) : null}
            <KakaoShareBtn onClick={onKakaoShare} />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default withRouter(EditPage);
